import {createSvgIcon} from "@mui/material";

export const ITAccessPointIcon = createSvgIcon(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.9604 21.0599C16.9641 21.0599 21.0204 17.0036 21.0204 11.9999C21.0204 6.99624 16.9641 2.93994 11.9604 2.93994C6.95669 2.93994 2.90039 6.99624 2.90039 11.9999C2.90039 17.0036 6.95669 21.0599 11.9604 21.0599Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.03 16.08C14.2557 16.08 16.06 14.2757 16.06 12.05C16.06 9.82431 14.2557 8.02002 12.03 8.02002C9.80429 8.02002 8 9.82431 8 12.05C8 14.2757 9.80429 16.08 12.03 16.08Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    'ITAccessPointIcon'
)